import { WebRoutes } from "consts/enpoints/web";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { Step, withApplication } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";
import usePaymentMethods from "./usePaymentMethods";

const PaymentMethods = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const paymentMethods = usePaymentMethods();

    return (
        <Step
            title='Payment Methods'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.HighRiskMerchant}
        >
            <HighRiskMerchant.PaymentMethods.Form
                {...paymentMethods}
                sx={{
                    '& > div': {
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: {
                            xs: '1fr',
                            md: '1fr 1fr'
                        }
                    }
                }}
            />
        </Step>
    );
};

export default withApplication(PaymentMethods);
